import { Component, OnInit, ElementRef, ViewChild, Input, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MediaInfo, MediaType } from '@core/models/media-info.model';
import { SwiperOptions } from 'swiper';
import { GalleryDialogComponent } from '../gallery-dialog/gallery-dialog.component';

@Component({
  selector: 'app-product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrls: ['./product-gallery.component.scss']
})

export class ProductGalleryComponent implements OnInit, OnChanges {
  galleryItemsCount: number;
  activeIndex = 0;
  configMainSlider: SwiperOptions = {
    centeredSlides: false,
    slidesPerView: 1,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    slidesPerGroup: 1,
    spaceBetween: 10,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.product-gallery__button-next',
      prevEl: '.product-gallery__button-prev',
    }
  };

  configCarousel: SwiperOptions = {
    centeredSlides: false,
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: '.product-gallery__carousel-next',
      prevEl: '.product-gallery__carousel-prev',
    }
  };

  @Input() items: MediaInfo[] = [];
  @Input() textCover: string | null = null;
  @Input() redCover: string | null = null;
  @ViewChild('thumbList', { static: false }) thumbList: ElementRef;

  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.updateGalleryWidth();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateGalleryWidth();
  }

  handleShowGallery(index: number = 0): void {
    if (!this.items[index]) {
      return;
    }

    const gallery: MediaInfo[] = [];
    this.items.map(item => {
      gallery.push({ ...item, type: item.is360view ? MediaType.Panorama : item.type });
    });

    this.dialog.open(GalleryDialogComponent, {
      backdropClass: 'p7d-overlay-gallery-backdrop',
      panelClass: 'gallery-dialog',
      data: {
        items: gallery,
        index
      }
    });
  }

  onSlideChange(swiper: any): void {
    this.activeIndex = swiper[0].realIndex;
  }

  @HostListener('window:resize', []) // for window scroll events
  onResize() {
    this.updateGalleryWidth();
  }

  updateGalleryWidth() {
    if (!this.thumbList) {
      return;
    }
    const thumbListWidth = this.thumbList.nativeElement.clientWidth;
    let availableItems = Math.round(thumbListWidth / 85);

    availableItems = Math.max(3, Math.min(5, availableItems));
    this.galleryItemsCount = availableItems;
  }

}


